import Header from '../../components/Header';
import { Grid, Stack, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';
import CustomCard from '../../components/CustomCard';
import { EXPERIENCES } from '../../constants/experience';
import Timeline from '../../components/Timeline';
import aboutIcon from '../../assets/icons/about.png';
import workIcon from '../../assets/icons/work.png';
import { useNavigate } from 'react-router-dom';
import Skills from './Skills';
import Projects from './Projects';
import useVisibilityOnScroll from '../../hooks/useVisibilityOnScroll';

const MotionGrid = motion(Grid);

const Home = () => {
  const [sectionRef, isSectionVisible] = useVisibilityOnScroll(0.2, true);
  const navigate = useNavigate()

  const containerVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.4, 0, 0.2, 1] as any
      }
    }
  };

  return (
    <Box>
      <Header />
      <MotionGrid
        ref={sectionRef}
        variants={containerVariants}
        initial="hidden"
        animate={isSectionVisible ? "visible" : "hidden"}
        sx={{ my: 3 }}
      >
        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 7 }}>
            <Stack>
              <CustomCard title="About" titleIcon={aboutIcon}>
                <Typography
                  sx={{
                    lineHeight: 1.8,
                    color: 'text.secondary',
                    fontSize: '15px',
                  }}
                >
                  I'm a full-stack developer specializing in the JavaScript ecosystem. With seven years of experience building and maintaining robust, scalable web applications across multiple industries, I bring a solid foundation in full-stack development with a particular focus on ReactJS, NodeJS, and relational databases.
                </Typography>
              </CustomCard>
              <Skills />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 5 }}>
            <CustomCard title="Experience" titleIcon={workIcon} link="View Details" handleLinkClick={() => navigate('/experience')}>
              <Timeline data={EXPERIENCES} />
            </CustomCard>
          </Grid>
        </Grid>
        <Box>
          <Projects />
        </Box>
      </MotionGrid>
    </Box>
  );
}

export default Home;